import { useEffect } from "react";
import { useToast } from "../state/toast";

// app-wide notice under the top bar (clear of the play dock and the key sheet at the bottom)
export function Toast() {
  const { msg, action, seq, hide } = useToast();
  useEffect(() => {
    if (!msg) return;
    const id = window.setTimeout(hide, action ? 4500 : 2600);
    return () => window.clearTimeout(id);
  }, [msg, action, seq, hide]);
  if (!msg) return null;
  return (
    <div className={"app-toast" + (action ? "" : " plain")} role="status">
      <span>{msg}</span>
      {action && <button onClick={() => { hide(); action.run(); }}>{action.label}</button>}
    </div>
  );
}
